var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHeartBreak = function SvgHeartBreak(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512px",
    viewBox: "0 -37 512.001 512",
    width: "512px",
    className: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m262.507812 343.902344-58.871093-58.566406 49.558593-49.558594c5.707032-5.707032 5.707032-15.320313 0-21.027344l-45.953124-45.953125 39.347656-97.914063c1.800781-4.804687 1.199218-10.210937-1.804688-14.414062-25.226562-35.441406-66.375-56.46875-109.925781-56.46875-79.292969 0-134.859375 62.175781-134.859375 150.777344 0 21.625 3.304688 41.152344 10.210938 59.472656 21.625 60.96875 77.792968 108.125 153.78125 171.796875 17.121093 14.117187 35.441406 29.734375 54.664062 46.257813 6.910156 6.003906 11.414062 11.410156 20.722656 8.40625 4.808594-1.5 8.710938-5.40625 9.914063-10.511719l17.121093-67.878907c1.199219-5.105468-.300781-10.511718-3.90625-14.417968zm0 0",
    fill: "#ff637b",
    "data-original": "#FF637B",
    className: "",
    "data-old_color": "#ff637b",
    style: {
      fill: "#62C4B2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m377.144531 0c-26.132812 0-51.660156 7.507812-73.589843 21.925781-2.699219 1.5-4.804688 4.203125-6.003907 6.90625l-49.257812 123.445313c-2.40625 5.707031-.902344 12.015625 3.300781 16.21875l56.769531 56.769531-49.558593 49.554687c-5.707032 5.707032-5.707032 15.320313 0 21.027344l44.75 45.050782-15.015626 60.671874c-1.800781 6.308594 1.203126 13.214844 6.609376 16.519532 8.40625 5.105468 14.714843 1.199218 21.023437-4.507813 43.550781-37.542969 78.09375-67.277343 108.425781-96.410156 31.839844-30.636719 61.875-64.277344 77.191406-106.925781 6.308594-18.023438 10.210938-37.84375 10.210938-59.46875 0-88.605469-55.5625-150.777344-134.855469-150.777344zm0 0",
    fill: "#ff637b",
    "data-original": "#FF637B",
    className: "",
    "data-old_color": "#ff637b",
    style: {
      fill: "#62C4B2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e63950"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m262.507812 343.902344c3.605469 3.90625 5.105469 9.3125 3.90625 14.417968l-17.121093 67.878907c-1.199219 5.105469-5.105469 9.011719-9.914063 10.511719-9.308594 3.003906-13.8125-2.402344-20.722656-8.410157-19.222656-16.519531-37.542969-32.136719-54.664062-46.253906-75.988282-63.675781-132.15625-110.828125-153.78125-171.800781h238.480468l4.503906 4.503906c5.707032 5.707031 5.707032 15.320312 0 21.023438l-49.558593 49.5625zm0 0",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    style: {
      fill: "#62C4B2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m501.789062 210.246094c-15.316406 42.648437-45.351562 76.289062-77.191406 106.925781-30.335937 29.132813-64.875 58.867187-108.425781 96.414063-6.308594 5.707031-12.617187 9.609374-21.027344 4.503906-5.40625-3.300782-8.410156-10.210938-6.605469-16.519532l15.015626-60.671874-44.75-45.050782c-5.707032-5.707031-5.707032-15.320312 0-21.027344l49.558593-49.554687-15.019531-15.019531zm0 0",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    style: {
      fill: "#62C4B2"
    }
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeartBreak, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/heart-break.4d0acc08.svg";
export { ForwardRef as ReactComponent };